import PricingMain from "@/components/pricing/pricing-main";

import Head from "next/head";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Pricing() {
  return (
    <>
      <Head>
        <title>{seoData.GUEST_SUBSCRIPTION_PAGE.title}</title>
        <SeoMetaData data={seoData.GUEST_SUBSCRIPTION_PAGE} />
      </Head>

      <PricingMain />
    </>
  );
}
